import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import "./style.css"
function NavbarComponent({ language, setLanguage,CompanyFirstName ,CompanyLastName }) {

  return (
    <Navbar  bg="dark" data-bs-theme="dark" expand="lg"         className="bg-body-tertiary" fixed="top">
      <Container >
          <Navbar.Brand href="#home" className="navbar-logo">
            {CompanyFirstName}   {CompanyLastName}
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="navbarScroll" />
          <Navbar.Collapse id="navbarScroll">
          <Nav className="me-auto my-2 my-lg-0"
                style={{ maxHeight: '100px' }}
                navbarScroll>
            
              <Nav.Link href="#home">Home</Nav.Link>
              <Nav.Link href="#Products">
                {language ? "Products" : "Producten "}
              </Nav.Link>
              <Nav.Link href="#services">
                {language ? "Services" : "Diensten"}
              </Nav.Link>
              <Nav.Link href="#contact">
                Contact
              </Nav.Link>
          </Nav>
          <Button className="fs-4 languageButton"
            variant="outline-danger"
            onClick={() => setLanguage(!language)}>
            {language ?"Nl 🇳🇱": "En 🇬🇧"}
          </Button>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}
export default NavbarComponent;
